import React from 'react';
import { ToolbarButton } from '@/components/creator/partials/toolbarButton/ToolbarButton';
import { useMediaQuery } from '@mantine/hooks';
import { Flex } from '@mantine/core';
import { ProjectRenderer } from '@/renderer/ProjectRenderer';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import MeasureIcon from '@/assets/icons/measure.svg?react';
import ZoomInIcon from '@/assets/icons/zoomIn.svg?react';
import ZoomOutIcon from '@/assets/icons/zoomOut.svg?react';
import CenterIcon from '@/assets/icons/centerRoom.svg?react';
import APP_CONFIG from '@/configs/appConfig';
import styles from './Toolbar.module.scss';

const baseSlug = 'toolbar.';

const renderer = ProjectRenderer.getInstance();

interface Props {
	zoomEnabled: {
		in: boolean;
		out: boolean;
	};
	handleZoom: (zoomAction: 'in' | 'out') => () => void;
	toggleFullscreen: () => Promise<void>;
	handleCenterView: () => void;
}

export const Toolbar: React.FC<Props> = ({
	zoomEnabled,
	handleZoom,
	toggleFullscreen,
	handleCenterView,
}) => {
	const dispatch = useTypedDispatch();

	const { options, product } = useTypedSelector((state) => state.creator);

	const isMobile = useMediaQuery(`(max-width: ${APP_CONFIG.BREAKPOINTS.MD})`);

	const toggleMeasureVisibility = () => {
		dispatch(
			creatorActions.updateOptions({
				isMetersVisible: !options.isMetersVisible,
			})
		);
		renderer.toggleBoxMeasuresVisibility();
	};

	const buttons = isMobile ? (
		<>
			<ToolbarButton
				Icon={MeasureIcon}
				tooltipProps={{
					label: options.isMetersVisible ? 'Ukryj wymiary' : 'Pokaż wymiary',
				}}
				onClick={toggleMeasureVisibility}
			/>
			<ToolbarButton
				Icon={CenterIcon}
				tooltipProps={{ opened: false, label: '' }}
				onClick={toggleFullscreen}
			/>
		</>
	) : (
		<>
			<ToolbarButton
				Icon={ZoomInIcon}
				tooltipProps={{ label: 'Przybliż' }}
				onClick={handleZoom('in')}
				disabled={!zoomEnabled.in || !product}
			/>
			<ToolbarButton
				Icon={ZoomOutIcon}
				tooltipProps={{ label: 'Oddal' }}
				onClick={handleZoom('out')}
				disabled={!zoomEnabled.out || !product}
			/>
			<ToolbarButton
				Icon={MeasureIcon}
				tooltipProps={{
					label: options.isMetersVisible ? 'Ukryj wymiary' : 'Pokaż wymiary',
				}}
				onClick={toggleMeasureVisibility}
			/>
		</>
	);

	return (
		<Flex gap="sm" className={styles.container}>
			{buttons}
		</Flex>
	);
};
